import {County} from "../../entity/model/county";
import CountyStore from "../store/county-store";

export default class CountyService {
    countyStore: CountyStore;

    constructor(countyStore: CountyStore) {
        this.countyStore = countyStore;
    }

    getCounties = async (): Promise<County[]> => {
        return this.countyStore.cache ? this.countyStore.counties : this.countyStore.getCounties();
    }

    getCountyById = async (countyId: string): Promise<County | undefined> => {
        return countyId !== null ? (await this.getCounties()).find((county: County) => county.id === countyId) : undefined;
    }

    getCountyByStateId = async (stateId: string): Promise<County[]> => {
        try {
            return await this.countyStore.getCountyByStateId(stateId);
        } catch (error) {
            const allCounties = await this.getCounties();
            return allCounties.filter(county => county.stateID === stateId);
        }
    }
}